<div class="cart">
    <div *ngIf="isLoading" class="cart__loading">
        <div class="spinner"></div>
    </div>

    <ng-container *ngIf="!isLoading">
        <div class="cart__page-head">
            <vsf-breadcrumbs [items]="[{ label: 'Home', link: '/' }, { label: 'Cart' }]"></vsf-breadcrumbs>
            <div class="cart__title-row">
                <h1 class="cart__title">Your cart</h1>
                <ng-container *ngIf="cart$ | async as cartHead">
                    <div
                        class="cart__title-actions"
                        *ngIf="cartHead.lines?.length"
                    >
                        <div class="cart__units-meta">
                            {{ getUnitCount(cartHead) }} units selected across
                            {{ getSupplierCount(cartHead) }}
                            {{
                                getSupplierCount(cartHead) === 1
                                    ? "supplier"
                                    : "suppliers"
                            }}
                        </div>
                        <div class="cart__head-btns">
                            <vsf-upload-cart-csv
                                buttonLabel="Import cart"
                                [customClass]="'cart__outline-btn'"
                                [failedProductGtins]="failedProductGtins"
                                [moqViolations]="moqViolations"
                                (failedProductGtinsChange)="
                                    failedProductGtins = $event
                                "
                                (moqViolationsChange)="moqViolations = $event"
                            ></vsf-upload-cart-csv>
                            <button
                                type="button"
                                class="cart__outline-btn"
                                (click)="exportCart(cartHead)"
                                aria-label="Export cart"
                            >
                                <img
                                    src="assets/icons/download-icon.svg"
                                    alt=""
                                />
                                Export cart
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

    <section *ngIf="importStockShortfalls.length" role="alert" class="my-4 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-gray-900">
        <div class="flex items-start justify-between gap-4"><div><h2 class="font-semibold">Import stock report</h2><p>Quantities were limited to available stock. The units below were not imported because they are out of stock.</p></div><button type="button" aria-label="Dismiss import stock report" (click)="dismissStockReport()">×</button></div>
        <div class="mt-3 max-h-64 overflow-auto">
            <table class="hidden sm:table w-full text-left"><thead><tr><th class="pr-4 py-1">EAN</th><th class="pr-4 py-1 text-right">Requested</th><th class="pr-4 py-1 text-right">Imported</th><th class="py-1 text-right">Not imported</th></tr></thead><tbody><tr *ngFor="let item of importStockShortfalls"><td class="pr-4 py-1">{{ item.gtin }}</td><td class="pr-4 py-1 text-right">{{ item.requestedQuantity }}</td><td class="pr-4 py-1 text-right">{{ item.importedQuantity }}</td><td class="py-1 text-right">{{ item.missingQuantity }}</td></tr></tbody></table>
            <div class="sm:hidden space-y-3"><article *ngFor="let item of importStockShortfalls"><strong class="break-all">EAN {{ item.gtin }}</strong><dl class="mt-1 grid grid-cols-3 gap-3 text-xs"><div><dt>Requested</dt><dd class="font-semibold">{{ item.requestedQuantity }}</dd></div><div><dt>Imported</dt><dd class="font-semibold">{{ item.importedQuantity }}</dd></div><div><dt>Not imported</dt><dd class="font-semibold">{{ item.missingQuantity }}</dd></div></dl></article></div>
        </div>
    </section>

        <ng-container *ngIf="cart$ | async as cart; else emptyCart">
        <div
            *ngIf="cart.lines?.length"
            class="cart__status"
            [class.cart__status--ready]="canProceedToCheckout(cart)"
            [class.cart__status--warn]="!canProceedToCheckout(cart)"
        >
            <img src="assets/icons/cart-status-info.svg" alt="" />
            <span>{{ getStatusLine(cart) }}</span>
        </div>

        <div *ngIf="cart.lines?.length; else emptyCart" class="cart__content">
            <div class="cart__main">
                <div *ngIf="belowMinimumSuppliersCount > 0" class="cart__optimizer">
                    <div class="cart__optimizer-row">
                        <span class="cart__optimizer-label">
                            <img src="assets/icons/cart-optimizer-sparkle.svg" alt="" />
                            Cart optimizer
                            <span class="cart__optimizer-hint"
                                >— close the gap to each supplier's MOV</span
                            >
                        </span>
                        <button
                            type="button"
                            class="cart__optimizer-btn"
                            (click)="openOptimizerModal()"
                        >
                            Optimize cart
                        </button>
                    </div>
                </div>

                <vsf-cart-contents
                    [cart]="cart"
                    [canAdjustQuantities]="true"
                    [canEdit]="true"
                    [isImporting]="isImporting"
                    [isEmpty]="false"
                    [failedProductGtins]="failedProductGtins"
                    [moqViolations]="moqViolations"
                    (removeAllItemsEvent)="removeAllItems()"
                    (setQuantity)="setQuantity($event)"
                    (removeItemEvent)="removeItem($event)"
                    (checkoutReadinessChange)="updateCheckoutReadiness($event)"
                    (includedChange)="onIncludedChange($event)"
                ></vsf-cart-contents>
            </div>

            <aside class="cart__column-aside">
                <div class="cart__totals-panel">
                    <div class="cart__summary-title">Order summary</div>
                    <div class="cart__summary-rows">
                        <div class="cart__total-row">
                            <span>Subtotal</span>
                            <span class="cart__total-row-value">{{
                                cart.subTotalWithTax | formatPrice
                            }}</span>
                        </div>
                        <div
                            class="cart__total-row cart__total-row--savings"
                            *ngIf="getVolumeSavings(cart) > 0"
                        >
                            <span>Volume discount</span>
                            <span class="cart__total-row-value"
                                >−{{ getVolumeSavings(cart) | formatPrice }}</span
                            >
                        </div>
                        <div class="cart__total-row cart__total-row--grand">
                            <span>Total</span>
                            <span class="cart__grand-total">{{
                                cart.totalWithTax | formatPrice
                            }}</span>
                        </div>
                    </div>

                    <div class="cart__ready-block">
                        <div class="cart__stat-row">
                            <span>Suppliers ready</span>
                            <span
                                class="cart__stat-value"
                                [class.cart__stat-value--ok]="
                                    readySuppliersCount === getSupplierCount(cart) &&
                                    getSupplierCount(cart) > 0
                                "
                                [class.cart__stat-value--warn]="
                                    readySuppliersCount < getSupplierCount(cart)
                                "
                            >
                                {{ readySuppliersCount }} of
                                {{ getSupplierCount(cart) }}
                            </span>
                        </div>
                        <div
                            class="cart__stat-row"
                            *ngIf="belowMinimumSuppliersCount > 0"
                        >
                            <span>Below MOV</span>
                            <span class="cart__stat-value cart__stat-value--below">{{
                                belowMinimumSuppliersCount
                            }}</span>
                        </div>
                        <div class="cart__stat-row">
                            <span>Ready for checkout</span>
                            <span class="cart__stat-value">{{
                                readyTotal | formatPrice
                            }}</span>
                        </div>
                    </div>

                    <button
                        type="button"
                        (click)="proceedToCheckout(cart)"
                        class="cart__checkout-btn"
                        [disabled]="!canProceedToCheckout(cart)"
                        [class.cart__checkout-btn--disabled]="
                            !canProceedToCheckout(cart)
                        "
                        [attr.aria-label]="getCheckoutLabel(cart)"
                    >
                        {{ getCheckoutLabel(cart) }}
                    </button>
                    <p class="cart__checkout-helper">
                        {{ getCheckoutHelper(cart) }}
                    </p>

                    <div
                        *ngIf="!canProceedToCheckout(cart) && hasStockIssues(cart)"
                        class="cart__checkout-error-message"
                    >
                        Some products are out of stock or exceed available stock.
                    </div>
                    <div
                        *ngIf="moqViolationsCount > 0"
                        class="cart__checkout-error-message"
                    >
                        MOQ not met for {{ moqViolationsCount }} SKU(s). Increase
                        quantities to proceed.
                    </div>

                    <div class="cart__trust">
                        <img src="assets/icons/cart-shield-check.svg" alt="" />
                        Protected payments · VAT-verified suppliers
                    </div>
                </div>
            </aside>
        </div>
        </ng-container>
    </ng-container>

    <ng-template #emptyCart>
        <div class="cart__empty">
            <div class="cart__empty-icon">
                <img src="assets/icons/cart-empty-bag.svg" alt="" />
            </div>
            <div class="cart__empty-title">Your cart is empty</div>
            <p class="cart__empty-text">
                Browse the catalog or search GTINs to find verified suppliers and
                add products to your cart.
            </p>
            <a
                [routerLink]="['/category/products']"
                class="cart__empty-btn"
                aria-label="Browse catalog"
            >
                Browse catalog →
            </a>
        </div>
    </ng-template>

    <div
        *ngIf="optimizerModalOpen"
        class="cart__opt-overlay"
        (click)="closeOptimizerModal()"
    >
        <div
            class="cart__opt-modal"
            (click)="$event.stopPropagation()"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cart-opt-title"
        >
            <div class="cart__opt-modal-head">
                <div id="cart-opt-title" class="cart__opt-modal-title">
                    Optimize cart
                </div>
                <button
                    type="button"
                    class="cart__opt-modal-close"
                    (click)="closeOptimizerModal()"
                    aria-label="Close"
                >
                    ×
                </button>
            </div>
            <div class="cart__opt-modal-body">
                <div class="cart__opt-goal-label">Optimize for</div>
                <button
                    type="button"
                    class="cart__opt-goal"
                    [class.cart__opt-goal--active]="optimizeGoal === 'mov'"
                    (click)="optimizeGoal = 'mov'"
                >
                    <span class="cart__opt-radio"
                        ><span class="cart__opt-radio-dot"></span
                    ></span>
                    <span>
                        <span class="cart__opt-goal-title"
                            >Meet supplier minimums</span
                        >
                        <span class="cart__opt-goal-desc"
                            >Suggest quantity increases so each included supplier
                            clears its MOV with the smallest spend increase.</span
                        >
                    </span>
                </button>
                <button
                    type="button"
                    class="cart__opt-goal"
                    [class.cart__opt-goal--active]="optimizeGoal === 'value'"
                    (click)="optimizeGoal = 'value'"
                >
                    <span class="cart__opt-radio"
                        ><span class="cart__opt-radio-dot"></span
                    ></span>
                    <span>
                        <span class="cart__opt-goal-title"
                            >Maximize volume discounts</span
                        >
                        <span class="cart__opt-goal-desc"
                            >Push groups into the next volume-discount tier when
                            the savings outweigh the added units.</span
                        >
                    </span>
                </button>
            </div>
            <div class="cart__opt-modal-foot">
                <button
                    type="button"
                    class="cart__outline-btn"
                    (click)="closeOptimizerModal()"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="cart__optimizer-btn"
                    (click)="applyOptimizer()"
                >
                    Optimize cart
                </button>
            </div>
        </div>
    </div>
</div>
